import { render, staticRenderFns } from "./thisCompany.vue?vue&type=template&id=325cc6d7&scoped=true"
import script from "./thisCompany.vue?vue&type=script&lang=js"
export * from "./thisCompany.vue?vue&type=script&lang=js"
import style0 from "./thisCompany.vue?vue&type=style&index=0&id=325cc6d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325cc6d7",
  null
  
)

export default component.exports